import { useLocation } from 'react-router-dom';
import { useApi } from '../../../../hooks/useApi';
import OzonAutomationsTab from './OzonAutomationsTab';
import './OzonBidder.css';

export default function OzonBidder({ accountId }) {
  const { request } = useApi();
  // Ссылка из уведомления несёт группу и вкладку (?automation=…&automation_tab=…).
  const { search } = useLocation();

  return (
    <div className='bidder'>
      <OzonAutomationsTab accountId={accountId} request={request} linkSearch={search} />
    </div>
  );
}
